import { useTranslation } from 'react-i18next';
import { NavLink } from '../../components/ui';
import useScreenTitle from '../../common/use-screen-title';
import './edit-locked-view.scss';

export const UgcEditLockedView = () => {
  const { t } = useTranslation();
  useScreenTitle(t('user_generated_content.edit_locked.title'));

  return (
    <div className="ugc-edit-locked">
      <div className="ugc-edit-locked__image">
        <img
          src="/images/feed-empty.svg"
          alt={t('user_generated_content.edit_locked.illustration_alt')}
        />
      </div>

      <div className="ugc-edit-locked__title text-heading-bold">
        {t('user_generated_content.edit_locked.title')}
      </div>

      <NavLink
        className="ugc-edit-locked__link text-body"
        href="/"
        action="push"
        exact
      >
        {t('user_generated_content.edit_locked.return_to_home')}
      </NavLink>
    </div>
  );
};

export default UgcEditLockedView;
